import { COMPOSER_OPEN_PARAM } from '~/constants/composer';

export const paramsToRemove = [
  COMPOSER_OPEN_PARAM,
  'merch_manage_alerts',
  'refSource',
  'searchEvent',
  'searchSource',
  'utm_term'
];

export const utmContentToRemove = ['saved_search_preferences'];
